import { Resource } from 'i18next';

const commonErrors: Resource = {
  fr: {
    commonErrors: {
      HTTP_401: 'Requête non autorisée.',
      HTTP_403: 'Requête interdite.',
      HTTP_404: "La ressource demandée n'a pu être trouvée.",
      HTTP_408: 'Requête expirée.',
      HTTP_409: 'Requête en conflit.',
      HTTP_429: 'Trop de requêtes exécutées.',
      RequestCanceledError: "L'opération a été annulée.",
      RequestTimeoutError: "L'opération n'a pu être exécutée dans le temps imparti.",
      NotImplementedError: "Cette fonctionalité n'est pas implémentée.",
      NotSupportedValueError: "La valeur spécifiée n'est pas supportée.",
      Unknown: 'Une erreur inconne est survenue. Réessayer de nouveau.',
    },
  },
  en: {
    commonErrors: {
      HTTP_401: 'Unauthorized request.',
      HTTP_403: 'Forbidden request.',
      HTTP_404: 'The requested resource could not be found.',
      HTTP_408: 'Request timeout.',
      HTTP_409: 'Request conflict.',
      HTTP_429: 'Too many requests.',
      RequestCanceledError: 'The operation has been canceled.',
      RequestTimeoutError: 'The operation has timed out',
      NotImplementedError: 'This functionality is not implemented',
      NotSupportedValueError: 'The specified value is not supported.',
      Unknown: 'An unknown error occurred. Please try again.',
    },
  },
};

export default commonErrors;
